import blue from 'material-ui/colors/blue';
import deepOrange from 'material-ui/colors/deepOrange';

export default {
    direction: 'rtl',
    palette: {
        primary: {
            light: blue[300],
            main: '#fdb813',
            dark: blue[700],
        },
        secondary: {
            light: deepOrange[300],
            main: '#0c4da2',
            dark: deepOrange[700],
        }
    },
    status: {
        danger: 'orange',
    },
    typography: {
        fontFamily: 'IRANSans',
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        },
    },
};



// WEBPACK FOOTER //
// ./containers/themes/blueTheme.js